import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { interval, takeWhile } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
})
export class CountdownComponent implements OnInit {
  @Input() endDate: Date;
  countdownTimer = { days: '00', hours: '00', minutes: '00', seconds: '00' };

  readonly calcs = {
    days: 1000 * 60 * 60 * 24,
    hours: 1000 * 60 * 60,
    minutes: 1000 * 60,
    seconds: 1000,
  };

  ngOnInit(): void {
    const endTime = this.endDate.getTime();
    const timer = interval(1000);
    timer
      .pipe(
        takeWhile(() => {
          const now = new Date().getTime();
          return endTime - now > 0;
        }),
        untilDestroyed(this)
      )
      .subscribe(() => {
        const now = new Date().getTime();
        const end = endTime - now;

        this.countdownTimer.days = this.formatNumber(Math.floor(end / this.calcs.days));
        this.countdownTimer.hours = this.formatNumber(Math.floor((end % this.calcs.days) / this.calcs.hours));
        this.countdownTimer.minutes = this.formatNumber(Math.floor((end % this.calcs.hours) / this.calcs.minutes));
        this.countdownTimer.seconds = this.formatNumber(Math.floor((end % this.calcs.minutes) / this.calcs.seconds));
      });
  }

  formatNumber(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }
}
